import __request__ from "routing/request";
export function buildBundle(requestOptions) {
  return __request__("POST", "/system/debug/support/bundle/build", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function download(filename, requestOptions) {
  return __request__("GET", `/system/debug/support/bundle/download/${filename}`, null, {}, {
    "Accept": ["application/octet-stream"]
  }, requestOptions);
}
export function listBundles(requestOptions) {
  return __request__("GET", "/system/debug/support/bundle/list", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function remove(filename, requestOptions) {
  return __request__("DELETE", `/system/debug/support/bundle/${filename}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getLogFile(id, requestOptions) {
  return __request__("GET", `/system/debug/support/logfile/${id}`, null, {}, {
    "Accept": ["application/octet-stream"]
  }, requestOptions);
}
export function getNodeManifest(requestOptions) {
  return __request__("GET", "/system/debug/support/manifest", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
